module.exports = __webpack_public_path__ + "img/menu_list.bf37606c.png";